import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { dropdown } from '../../../../animations';
import { LienItemModel } from '../../../../models/menu/lien-item.model';
import { MenuItemModel } from '../../../../models/menu/menu-item.model';
import { MenuStateModel } from '../../../../models/menu/menu-state.model';
import { BreadcrumbsService } from '../../../breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item-left.component.html',
  styleUrls: ['./menu-item-left.component.scss'],
  animations: [dropdown],
})
export class MenuItemLeftComponent implements OnInit {
  sousMenuOpen = false;
  hasChildRouterActive = false;
  private _selected = false;

  @Input() menuState: MenuStateModel;
  @Input() menuItem: MenuItemModel;

  @Input() set selected(value: boolean) {
    this._selected = value;
    if (!value) {
      this.selectedSousMenu = null;
      this.sousMenuOpen = false;
      this.hasChildRouterActive = false;
    }
  }

  @Output() requestActivation = new EventEmitter();
  private selectedSousMenu: LienItemModel;

  constructor(private breadcrumbService: BreadcrumbsService) {
  }

  get selected() {
    return this._selected;
  }

  get hasSousMenu(): boolean {
    return this.menuItem && this.menuItem.sousMenu.length > 0;
  }

  get isSousMenuDisplayed(): boolean {
    return this.sousMenuOpen || (this.menuState.isReduced && !this.menuState.isMenuMobileOpened);
  }

  get stateAnimation(): string {
    if (this.menuState.isReduced) {
      return 'is-inactif';
    }
    return 'is-actif';
  }

  switchSousMenuOpen() {
    this.sousMenuOpen = !this.sousMenuOpen;
    if (this.sousMenuOpen) {
      this.requestActivation.emit();
    }
  }

  ngOnInit(): void {}

  clickMenuItem(event: Event, sousMenu: LienItemModel = null) {
    event.stopPropagation();
    this.breadcrumbService.clearHistory();
    this.selectedSousMenu = sousMenu;
    this.menuState.isMenuMobileOpened = false;
    this.requestActivation.next();
  }

  isSousMenuActif(sousMenu) {
    return this.selectedSousMenu == sousMenu;
  }

  isMenuActif() {
    return this.selected;
  }
}
